<template>
    <el-dialog :visible.sync="showDetail" id="typeshowhtml" custom-class='xiangqing'  v-dialogDrag>
            <el-form>
             <div class="contrascont">
                <div class="hst">{{currentDetailInfo.projectLampparamVo.lampparamNo}} {{currentDetailInfo.projectLampparamVo.lampTypeStr}}</div>
                <div class="lsde">
                    <div class="toppom">
                        <div v-if="currentDetailInfo.projectLampparamVo.makingWay == 2">
                            <embed :src="this.ImgPath + currentDetailInfo.projectLampparamVo.pdfPath" width="100%" height="725px">
                        </div>
                        <ul class="wid100" v-else>
                            <li class="title">应用需求</li>
                            <li class="cd1">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                        应用面示意图
                                    </div>
                                </div>
                            </li>
                            <li class="cd2">
                               <img :src="'data:image/png;base64,'+currentDetailInfo.projectLampparamVo.contestSketch" alt="">    
                            </li>
                            <li class="cd1">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                       灯具示意图
                                    </div>
                                </div>
                            </li>
                            <li class="cd2">
                               <img :src="'data:image/png;base64,'+currentDetailInfo.projectLampparamVo.lampSketch" alt="">    
                            </li>
                            <li class="cd3">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                       应用面类型
                                    </div>
                                </div>
                            </li>
                            <li class="cd4">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                       {{currentDetailInfo.projectLampparamVo.contestTypeString}}
                                    </div>
                                </div>
                            </li>
                            <!-- 隐藏 单侧导光、双侧导光、自发光线、光电玻璃、控光点光源、不控光点光源、远视点光源-->
                            <li class="cd3">
                                <div class="BoxTable" v-if="currentDetailInfo.projectLampparamVo.contestTypeString != '单侧导光' && currentDetailInfo.projectLampparamVo.contestTypeString != '双侧导光' && currentDetailInfo.projectLampparamVo.contestTypeString != '自发光线' && currentDetailInfo.projectLampparamVo.contestTypeString != '光电玻璃' && currentDetailInfo.projectLampparamVo.contestTypeString != '控光点光源' && currentDetailInfo.projectLampparamVo.contestTypeString != '不控光点光源' && currentDetailInfo.projectLampparamVo.contestTypeString != '远视点光源'">
                                    <div class="BoxCell">
                                       反射率
                                    </div>
                                </div>
                            </li>
                            <li class="cd4" >
                                <div class="BoxTable" v-if="currentDetailInfo.projectLampparamVo.contestTypeString != '单侧导光' && currentDetailInfo.projectLampparamVo.contestTypeString != '双侧导光' && currentDetailInfo.projectLampparamVo.contestTypeString != '自发光线' && currentDetailInfo.projectLampparamVo.contestTypeString != '光电玻璃' && currentDetailInfo.projectLampparamVo.contestTypeString != '控光点光源' && currentDetailInfo.projectLampparamVo.contestTypeString != '不控光点光源' && currentDetailInfo.projectLampparamVo.contestTypeString != '远视点光源'">
                                    <div class="BoxCell">
                                       {{currentDetailInfo.projectLampparamVo.albedo}}
                                    </div>
                                </div>
                            </li>
                            <!-- 隐藏 单侧导光、双侧导光、自发光线、光电玻璃、控光点光源、不控光点光源、远视点光源-->
                            <li class="cd5">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                       注：灯具图片仅作参考，灯珠排布及灯具外型由厂家深化，设计方及业主方最终确定，灯具尺寸不大于图示尺寸
                                    </div>
                                </div>
                            </li>
                            <li class="title">照明需求</li>
                            <li class="cd1 scd">
                                <div class="scd_lt">
                                    <div class="BoxTable">
                                        <div class="BoxCell">
                                        量化指标
                                        </div>
                                    </div>
                                </div>
                                <div class="scd_rt" v-if="currentDetailInfo.projectParamindexList.length > 0">
                                        <!-- 应用类型  洗墙、柱子、瓦楞 单侧导光、双侧导光、光电玻璃、自发光线 为一类  暗斑高度是洗墙、立柱、复合面、窗框 -->
                                        <ul class="uls lianghua" v-if="currentDetailInfo.projectLampparamVo.contestTypeString=='洗墙' || currentDetailInfo.projectLampparamVo.contestTypeString=='柱子' || currentDetailInfo.projectLampparamVo.contestTypeString=='瓦楞' || currentDetailInfo.projectLampparamVo.contestTypeString=='自发光线'|| currentDetailInfo.projectLampparamVo.contestTypeString=='单侧导光'|| currentDetailInfo.projectLampparamVo.contestTypeString=='双侧导光' ">
                                                 <table border>
                                                    <tr>
                                                        <th v-if="currentDetailInfo.projectLampparamVo.colorType == '2'">颜色</th>
                                                        <th width='190'>平均亮度(cd/㎡)</th>
                                                        <th>最大亮度(cd/㎡)</th>
                                                        <th>最小亮度(cd/㎡)</th>
                                                        <th>均匀度</th>
                                                        <th v-if="currentDetailInfo.projectLampparamVo.contestTypeString=='洗墙' || currentDetailInfo.projectLampparamVo.contestTypeString=='柱子' || currentDetailInfo.projectLampparamVo.contestTypeString=='瓦楞'">暗斑高度(m)</th>
                                                    </tr>
                                                    <tr>
                                                        <td v-if="currentDetailInfo.projectLampparamVo.colorType == '2'">全亮</td>
                                                        <td class="pingjun">
                                                            <el-form-item>
                                                                {{currentDetailInfo.projectParamindexList[0].brightnessAvgMin}}
                                                            </el-form-item>
                                                             <span class="xias" v-show="currentDetailInfo.projectParamindexList[0].brightnessAvgMin != ''&&currentDetailInfo.projectParamindexList[0].brightnessAvgMin != null">~</span> 
                                                            <el-form-item>
                                                                {{currentDetailInfo.projectParamindexList[0].brightnessAvgMax}}
                                                            </el-form-item>
                                                        </td>
                                                        <td>
                                                            <el-form-item>
                                                                <span v-show="currentDetailInfo.projectParamindexList[0].brightnessMax != ''&&currentDetailInfo.projectParamindexList[0].brightnessMax != null">≤</span>
                                                                {{currentDetailInfo.projectParamindexList[0].brightnessMax}}
                                                            </el-form-item>
                                                        </td>
                                                        <td>
                                                            <el-form-item>
                                                                <span v-show="currentDetailInfo.projectParamindexList[0].brightnessMin != ''&&currentDetailInfo.projectParamindexList[0].brightnessMin != null">≥</span>
                                                               {{currentDetailInfo.projectParamindexList[0].brightnessMin}}
                                                            </el-form-item>
                                                        </td>
                                                        <td>
                                                            <el-form-item>
                                                                <span v-show="currentDetailInfo.projectParamindexList[0].evenness != ''&&currentDetailInfo.projectParamindexList[0].evenness != null">≥</span>
                                                                {{currentDetailInfo.projectParamindexList[0].evenness}}
                                                            </el-form-item>
                                                        </td>
                                                        <td v-if="currentDetailInfo.projectLampparamVo.contestTypeString=='洗墙' || currentDetailInfo.projectLampparamVo.contestTypeString=='柱子' || currentDetailInfo.projectLampparamVo.contestTypeString=='瓦楞'">
                                                            <el-form-item>
                                                                <span v-show="currentDetailInfo.projectParamindexList[0].maculaHight != ''&& currentDetailInfo.projectParamindexList[0].maculaHight != null">≤</span>
                                                                {{currentDetailInfo.projectParamindexList[0].maculaHight}}
                                                                <!-- <span v-show="currentDetailInfo.projectParamindexList[0].maculaHight != ''&& currentDetailInfo.projectParamindexList[0].maculaHight != null">m</span> -->
                                                            </el-form-item>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="currentDetailInfo.projectLampparamVo.colorType == '2'">
                                                        <td>
                                                            {{currentDetailInfo.projectParamindexList[0].colorTemperatureCustom}}
                                                        </td>
                                                        <td class="pingjun">
                                                            <el-form-item>
                                                                {{currentDetailInfo.projectParamindexList[0].brightnessAvgMinCustom}}
                                                            </el-form-item>
                                                             <span class="xias" v-show="currentDetailInfo.projectParamindexList[0].brightnessAvgMinCustom != ''&& currentDetailInfo.projectParamindexList[0].brightnessAvgMinCustom != null">~</span> 
                                                            <el-form-item>
                                                                {{currentDetailInfo.projectParamindexList[0].brightnessAvgMaxCustom}}
                                                            </el-form-item>
                                                        </td>
                                                        
                                                    </tr>
                                                </table>
                                           
                                        </ul>
                                        
                                        <!--窗框、复合面  -->
                                        <ul class="uls lianghua" v-if="currentDetailInfo.projectLampparamVo.contestTypeString=='窗框' || currentDetailInfo.projectLampparamVo.contestTypeString=='复合面' ">
                                            
                                        
                                                 <table  border>
                                                    <tr>
                                                        <th v-if="currentDetailInfo.projectLampparamVo.colorType == '2'">颜色</th>
                                                        <th>应用面</th>
                                                        <th width='190'>平均亮度(cd/㎡)</th>
                                                        <th>最大亮度(cd/㎡)</th>
                                                        <th>最小亮度(cd/㎡)</th>
                                                        <th>均匀度</th>
                                                        <th>暗斑高度(m)</th>
                                                    </tr>
                                                    <tr>
                                                        <td v-if="currentDetailInfo.projectLampparamVo.colorType == '2'" rowspan="2">全亮</td>
                                                        <td>A面</td>
                                                        <td class="pingjun">
                                                            <el-form-item>
                                                                {{currentDetailInfo.projectParamindexList[0].brightnessAvgMin}}
                                                            </el-form-item>
                                                             <span class="xias" v-show="currentDetailInfo.projectParamindexList[0].brightnessAvgMin != ''&&currentDetailInfo.projectParamindexList[0].brightnessAvgMin != null">~</span> 
                                                            <el-form-item>
                                                                {{currentDetailInfo.projectParamindexList[0].brightnessAvgMax}}
                                                            </el-form-item>
                                                        </td>
                                                        <td>
                                                            <el-form-item>
                                                                 <span v-show="currentDetailInfo.projectParamindexList[0].brightnessMax != ''&&currentDetailInfo.projectParamindexList[0].brightnessMax != null">≤</span>
                                                                {{currentDetailInfo.projectParamindexList[0].brightnessMax}}
                                                            </el-form-item>
                                                        </td>
                                                        <td>
                                                            <el-form-item>
                                                                 <span v-show="currentDetailInfo.projectParamindexList[0].brightnessMin != ''&&currentDetailInfo.projectParamindexList[0].brightnessMin != null">≥</span>
                                                                {{currentDetailInfo.projectParamindexList[0].brightnessMin}}
                                                            </el-form-item>
                                                        </td>
                                                        <td>
                                                            <el-form-item>
                                                                 <span v-show="currentDetailInfo.projectParamindexList[0].evenness != ''&&currentDetailInfo.projectParamindexList[0].evenness != null">≥</span>
                                                                {{currentDetailInfo.projectParamindexList[0].evenness}}
                                                            </el-form-item>
                                                        </td>
                                                        <td>
                                                            <el-form-item>
                                                                 <span v-show="currentDetailInfo.projectParamindexList[0].maculaHight != ''&&currentDetailInfo.projectParamindexList[0].maculaHight != null">≤</span>
                                                               {{currentDetailInfo.projectParamindexList[0].maculaHight}}
                                                               <!-- <span v-show="currentDetailInfo.projectParamindexList[0].maculaHight != ''&&currentDetailInfo.projectParamindexList[0].maculaHight != null">m</span> -->
                                                            </el-form-item>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>B面</td>
                                                        <td class="pingjun">
                                                            <el-form-item>
                                                                {{currentDetailInfo.projectParamindexList[1].brightnessAvgMin}}
                                                            </el-form-item>
                                                             <span class="xias" v-show="currentDetailInfo.projectParamindexList[1].brightnessAvgMin != ''&&currentDetailInfo.projectParamindexList[1].brightnessAvgMin != null">~</span> 
                                                            <el-form-item>
                                                                {{currentDetailInfo.projectParamindexList[1].brightnessAvgMax}}
                                                            </el-form-item>
                                                        </td>
                                                        <td>
                                                            <el-form-item  v-show="currentDetailInfo.projectParamindexList[1].brightnessMax != null && currentDetailInfo.projectParamindexList[1].brightnessMax != ''">
                                                                ≤{{currentDetailInfo.projectParamindexList[1].brightnessMax}}
                                                            </el-form-item>
                                                        </td>
                                                        <td>
                                                            <el-form-item v-show="currentDetailInfo.projectParamindexList[1].brightnessMin != null && currentDetailInfo.projectParamindexList[1].brightnessMin != ''">
                                                                ≥{{currentDetailInfo.projectParamindexList[1].brightnessMin}}
                                                            </el-form-item>
                                                        </td>
                                                        <td>
                                                            <el-form-item  v-show="currentDetailInfo.projectParamindexList[1].evenness != null && currentDetailInfo.projectParamindexList[1].evenness != ''">
                                                                ≥{{currentDetailInfo.projectParamindexList[1].evenness}}
                                                            </el-form-item>
                                                        </td>
                                                        <td>
                                                            <el-form-item v-show="currentDetailInfo.projectParamindexList[1].maculaHight != ''&&currentDetailInfo.projectParamindexList[1].maculaHight != null">
                                                                ≤{{currentDetailInfo.projectParamindexList[1].maculaHight}}
                                                                <!-- <span v-show="currentDetailInfo.projectParamindexList[1].maculaHight != ''&&currentDetailInfo.projectParamindexList[1].maculaHight != null">m</span> -->
                                                            </el-form-item>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="currentDetailInfo.projectLampparamVo.colorType == '2'">
                                                        <td rowspan="2">
                                                            {{currentDetailInfo.projectParamindexList[0].colorTemperatureCustom}}
                                                        </td>
                                                        <td>A面</td>
                                                        <td class="pingjun">
                                                            <el-form-item>
                                                                {{currentDetailInfo.projectParamindexList[0].brightnessAvgMinCustom}}
                                                            </el-form-item>
                                                             <span class="xias" v-show="currentDetailInfo.projectParamindexList[0].brightnessAvgMinCustom != ''&&currentDetailInfo.projectParamindexList[0].brightnessAvgMinCustom != null">~</span> 
                                                            <el-form-item>
                                                                {{currentDetailInfo.projectParamindexList[0].brightnessAvgMaxCustom}}
                                                            </el-form-item>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="currentDetailInfo.projectLampparamVo.colorType == '2'">
                                                        <td>B面</td>
                                                        <td class="pingjun">
                                                            <el-form-item>
                                                                {{currentDetailInfo.projectParamindexList[1].brightnessAvgMinCustom}}
                                                            </el-form-item>
                                                             <span class="xias" v-show="currentDetailInfo.projectParamindexList[1].brightnessAvgMaxCustom != ''&&currentDetailInfo.projectParamindexList[1].brightnessAvgMaxCustom != null">~</span> 
                                                            <el-form-item>
                                                                {{currentDetailInfo.projectParamindexList[1].brightnessAvgMaxCustom}}
                                                            </el-form-item>
                                                        </td>
                                                    </tr>
                                                </table>
                                           
                                        </ul>

                                        <!--正投 -->
                                        <ul class="uls lianghua" v-if="currentDetailInfo.projectLampparamVo.contestTypeString=='正投'">
                                           
                                                 <table border>
                                                    <tr>
                                                        <th v-if="currentDetailInfo.projectLampparamVo.colorType == '2'" width='50'>颜色</th>
                                                        <th width='190'>平均亮度(cd/㎡)</th>
                                                        <th>
                                                            <span v-if="currentDetailInfo.projectLampparamVo.brightnessMax == 'brightnessMax'">最大亮度(cd/㎡)</span>
                                                            <span v-else>A点亮度(cd/㎡)</span>
                                                        </th>
                                                        <th>均匀度</th>
                                                        <th>b/c亮度比</th>
                                                    </tr>
                                                    <tr>
                                                        <td v-if="currentDetailInfo.projectLampparamVo.colorType == '2'">全亮</td>
                                                        <td class="pingjun">
                                                            <el-form-item>
                                                                {{currentDetailInfo.projectParamindexList[0].brightnessAvgMin}}
                                                            </el-form-item>
                                                             <span class="xias" v-show="currentDetailInfo.projectParamindexList[0].brightnessAvgMin != ''&&currentDetailInfo.projectParamindexList[0].brightnessAvgMin != null">~</span> 
                                                            <el-form-item>
                                                                {{currentDetailInfo.projectParamindexList[0].brightnessAvgMax}}
                                                            </el-form-item>
                                                        </td>
                                                        <td>
                                                            <el-form-item v-if="currentDetailInfo.projectLampparamVo.brightnessMax == 'brightnessMax'">
                                                                <span v-show="currentDetailInfo.projectParamindexList[0].brightnessMax != null && currentDetailInfo.projectParamindexList[0].brightnessMax != ''">≤</span><span>{{currentDetailInfo.projectParamindexList[0].brightnessMax}}</span>
                                                            </el-form-item>
                                                            <el-form-item v-else>
                                                                <span v-show="currentDetailInfo.projectParamindexList[0].brightnessA != null && currentDetailInfo.projectParamindexList[0].brightnessA != ''">≤</span><span>{{currentDetailInfo.projectParamindexList[0].brightnessA}}</span>
                                                            </el-form-item>
                                                        </td>
                                                        <td>
                                                            <el-form-item>
                                                                <span v-show="currentDetailInfo.projectParamindexList[0].evenness != ''&&currentDetailInfo.projectParamindexList[0].evenness != null">≥</span>{{currentDetailInfo.projectParamindexList[0].evenness}}
                                                            </el-form-item>
                                                        </td>
                                                        <td>
                                                            <el-form-item>
                                                                {{currentDetailInfo.projectParamindexList[0].bcBrightnessRatioMin}}
                                                            </el-form-item>
                                                            <span class="xias" v-show="currentDetailInfo.projectParamindexList[0].bcBrightnessRatioMin != ''&&currentDetailInfo.projectParamindexList[0].bcBrightnessRatioMin != null">~</span> 
                                                            <el-form-item>
                                                                {{currentDetailInfo.projectParamindexList[0].bcBrightnessRatioMax}}
                                                            </el-form-item>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="currentDetailInfo.projectLampparamVo.colorType == '2'">
                                                        <td>
                                                            {{currentDetailInfo.projectParamindexList[0].colorTemperatureCustom}}
                                                        </td>
                                                        <td class="pingjun">
                                                            <el-form-item>
                                                                {{currentDetailInfo.projectParamindexList[0].brightnessAvgMinCustom}}
                                                            </el-form-item>
                                                             <span class="xias" v-show="currentDetailInfo.projectParamindexList[0].brightnessAvgMinCustom != ''&&currentDetailInfo.projectParamindexList[0].brightnessAvgMinCustom != null">~</span> 
                                                            <el-form-item>
                                                                {{currentDetailInfo.projectParamindexList[0].brightnessAvgMaxCustom}}
                                                            </el-form-item>
                                                        </td>
                                                        
                                                    </tr>
                                                </table>
                                          
                                        </ul>

                                        <!-- 不控光点光源-->
                                        <ul class="uls lianghua" v-if="currentDetailInfo.projectLampparamVo.contestTypeString=='不控光点光源'">
                                            
                                                 <table border >
                                                    <tr>
                                                        <td>颜色</td>
                                                        <th>0°(cd)</th>
                                                        <th>上60°(cd)</th>
                                                        <th>下60°(cd)</th>
                                                        <th>左60°(cd)</th>
                                                        <th>右60°(cd)</th>
                                                    </tr>
                                                    <tr>
                                                        <td>全亮</td>
                                                        <td>
                                                            <el-form-item>
                                                                <span v-show="currentDetailInfo.projectParamindexList[0].level0 != ''&&currentDetailInfo.projectParamindexList[0].level0 != null">≥</span>{{currentDetailInfo.projectParamindexList[0].level0}}
                                                            </el-form-item>
                                                        </td>
                                                        <td>
                                                            <el-form-item>
                                                                <span v-show="currentDetailInfo.projectParamindexList[0].verticalUp60 != ''&&currentDetailInfo.projectParamindexList[0].verticalUp60 != null">≥</span>{{currentDetailInfo.projectParamindexList[0].verticalUp60}}
                                                            </el-form-item>
                                                        </td>
                                                        <td>
                                                            <el-form-item>
                                                                <span v-show="currentDetailInfo.projectParamindexList[0].verticalDown60 != ''&&currentDetailInfo.projectParamindexList[0].verticalDown60 != null">≥</span>{{currentDetailInfo.projectParamindexList[0].verticalDown60}}
                                                            </el-form-item>
                                                        </td>
                                                        <td>
                                                            <el-form-item>
                                                                <span v-show="currentDetailInfo.projectParamindexList[0].levelLeft60 != ''&&currentDetailInfo.projectParamindexList[0].levelLeft60 != null">≥</span>{{currentDetailInfo.projectParamindexList[0].levelLeft60}}
                                                            </el-form-item>
                                                        </td>
                                                        <td>
                                                            <el-form-item>
                                                                <span v-show="currentDetailInfo.projectParamindexList[0].levelRight60 != ''&&currentDetailInfo.projectParamindexList[0].levelRight60 != null">≥</span>{{currentDetailInfo.projectParamindexList[0].levelRight60}}
                                                            </el-form-item>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="currentDetailInfo.projectLampparamVo.colorType == '2'">
                                                        <td>{{currentDetailInfo.projectParamindexList[0].colorTemperatureCustom}}</td>
                                                        <td>
                                                            ≥{{currentDetailInfo.projectParamindexList[0].level0Custom}}
                                                        </td>
                                                    </tr>
                                                </table>
                                           
                                        </ul>
                                        <!-- 控光点光源-->
                                        <ul class="uls lianghua" v-if="currentDetailInfo.projectLampparamVo.contestTypeString=='控光点光源'">
                                            
                                                 <table  border>
                                                    <tr>
                                                        <td>颜色</td>
                                                        <th>0°(cd)</th>
                                                        <th>上30°(cd)</th>
                                                        <th>下60°(cd)</th>
                                                        <th>左60°(cd)</th>
                                                        <th>右60°(cd)</th>
                                                    </tr>
                                                    <tr>
                                                        <td>全亮</td>
                                                        <td>
                                                            <el-form-item >
                                                                 <span v-show="currentDetailInfo.projectParamindexList[0].level0 != ''&&currentDetailInfo.projectParamindexList[0].level0 != null">≥</span>  {{currentDetailInfo.projectParamindexList[0].level0}}
                                                            </el-form-item>
                                                        </td>
                                                        <td class="pingjun"> 
                                                            <el-form-item>
                                                                {{currentDetailInfo.projectParamindexList[0].verticalUp30}}
                                                            </el-form-item>
                                                             <span class="xias" v-show="currentDetailInfo.projectParamindexList[0].verticalUp30 != ''&&currentDetailInfo.projectParamindexList[0].verticalUp30 != null">~</span> 
                                                            <el-form-item>
                                                                {{currentDetailInfo.projectParamindexList[0].verticalUp30Max}}
                                                            </el-form-item>
                                                        </td>
                                                        <td>
                                                            <el-form-item>
                                                                  <span v-show="currentDetailInfo.projectParamindexList[0].verticalDown60 != ''&&currentDetailInfo.projectParamindexList[0].verticalDown60 != null">≥</span>{{currentDetailInfo.projectParamindexList[0].verticalDown60}}
                                                            </el-form-item>
                                                        </td>
                                                        <td>
                                                            <el-form-item>
                                                                  <span v-show="currentDetailInfo.projectParamindexList[0].levelLeft60 != ''&&currentDetailInfo.projectParamindexList[0].levelLeft60 != null">≥</span>{{currentDetailInfo.projectParamindexList[0].levelLeft60}}
                                                            </el-form-item>
                                                        </td>
                                                        <td>
                                                            <el-form-item>
                                                                 <span v-show="currentDetailInfo.projectParamindexList[0].levelRight60 != ''&&currentDetailInfo.projectParamindexList[0].levelRight60 != null">≥</span>{{currentDetailInfo.projectParamindexList[0].levelRight60}} 
                                                            </el-form-item>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="currentDetailInfo.projectLampparamVo.colorType == '2'">
                                                        <td>{{currentDetailInfo.projectParamindexList[0].colorTemperatureCustom}}</td>
                                                        <td>
                                                            ≥{{currentDetailInfo.projectParamindexList[0].level0Custom}}
                                                        </td>
                                                    </tr>
                                                </table>
                                        
                                        </ul>
                                        <!-- 远视点光源-->
                                        <ul class="uls lianghua" v-if="currentDetailInfo.projectLampparamVo.contestTypeString=='远视点光源'">
                                            
                                                 <table  border>
                                                    <tr>
                                                        <td>颜色</td>
                                                        <th>上30°(cd)</th>
                                                        <th>下10°(cd)</th>
                                                        <th>下45°(cd)</th>
                                                        <th>下10°左60°(cd)</th>
                                                        <th>下10°右60°(cd)</th>
                                                    </tr>
                                                    <tr>
                                                        <td>全亮</td>
                                                        <td class="pingjun">
                                                            <el-form-item>
                                                                {{currentDetailInfo.projectParamindexList[0].verticalUp30}}
                                                            </el-form-item>
                                                             <span class="xias" v-show="currentDetailInfo.projectParamindexList[0].verticalUp30 != ''&&currentDetailInfo.projectParamindexList[0].verticalUp30 != null">~</span> 
                                                            <el-form-item>
                                                                {{currentDetailInfo.projectParamindexList[0].verticalUp30Max}}
                                                            </el-form-item>
                                                        </td>
                                                        <td>
                                                            <el-form-item>
                                                                <span v-show="currentDetailInfo.projectParamindexList[0].verticalDown10 != ''&&currentDetailInfo.projectParamindexList[0].verticalDown10 != null">≥</span>{{currentDetailInfo.projectParamindexList[0].verticalDown10}}
                                                            </el-form-item>
                                                        </td>
                                                        <td class="pingjun">
                                                            <el-form-item>
                                                               
                                                                {{currentDetailInfo.projectParamindexList[0].down45}}
                                                            </el-form-item>
                                                             <span class="xias" v-show="currentDetailInfo.projectParamindexList[0].down45 != ''&&currentDetailInfo.projectParamindexList[0].down45 != null">~</span> 
                                                            <el-form-item>
                                                                {{currentDetailInfo.projectParamindexList[0].down45Max}}
                                                            </el-form-item>
                                                        </td>
                                                        <td>
                                                            <el-form-item>
                                                                <span v-show="currentDetailInfo.projectParamindexList[0].vertical10Left60 != ''&&currentDetailInfo.projectParamindexList[0].vertical10Left60 != null">≥</span>{{currentDetailInfo.projectParamindexList[0].vertical10Left60}}
                                                            </el-form-item>
                                                        </td>
                                                        <td>
                                                            <el-form-item>
                                                                <span v-show="currentDetailInfo.projectParamindexList[0].vertical10Right60 != ''&&currentDetailInfo.projectParamindexList[0].vertical10Right60 != null">≥</span>{{currentDetailInfo.projectParamindexList[0].vertical10Right60}}
                                                            </el-form-item>
                                                        </td>
                                                    </tr>
                                                     <tr v-if="currentDetailInfo.projectLampparamVo.colorType == '2'">
                                                        <td>{{currentDetailInfo.projectParamindexList[0].colorTemperatureCustom}}</td>
                                                        <td></td>
                                                        <td>
                                                            ≥{{currentDetailInfo.projectParamindexList[0].verticalDown10Custom}}
                                                        </td>
                                                    </tr>
                                                </table>
                                           
                                        </ul>
                                </div>
                            </li>
                            <li class="cd7">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                       效果描述
                                    </div>
                                </div>
                            </li>
                            <li class="cd8">
                                <div class="BoxTable">
                                    <div class="BoxCell" v-html="currentDetailInfo.projectLampparamVo.effectDescription">
                                    </div>
                                </div>
                            </li>
                            <li class="title">设备需求</li>
                            <li class="cd7">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                       光源类型
                                    </div>
                                </div>
                            </li>
                            <li class="cd9">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                       {{currentDetailInfo.projectLampparamVo.lightType}}
                                    </div>
                                </div>
                            </li>
                            <li class="cd7">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                       工作电压
                                    </div>
                                </div>
                            </li>
                            <li class="cd9">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                        {{currentDetailInfo.projectLampparamVo.workVoltagePrefix}} {{currentDetailInfo.projectLampparamVo.workVoltage}} <span v-show="currentDetailInfo.projectLampparamVo.workVoltage != null && currentDetailInfo.projectLampparamVo.workVoltage != ''">V</span>
                                    </div>
                                </div>
                            </li>

                            <li class="cd7">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                       灯具功率
                                    </div>
                                </div>
                            </li>
                            <li class="cd9">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                        <el-form-item v-show="currentDetailInfo.projectLampparamVo.lampPower != ''"> ≤{{currentDetailInfo.projectLampparamVo.lampPower}} {{currentDetailInfo.projectLampparamVo.lampPowerUnit}}</el-form-item>
                                    </div>
                                </div>
                            </li>
                            <li class="cd7">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                       安装方向
                                    </div>
                                </div>
                            </li>
                            <li class="cd9">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                        {{currentDetailInfo.projectLampparamVo.installDirection}}
                                    </div>
                                </div>
                            </li>
                            <li class="widTabless">
                                <ul>
                            <li class="cd7">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                       色温色彩
                                    </div>
                                </div>
                            </li>
                            <li class="cd9 widTable">
                                <div class="rtt">
                                    <span v-if="currentDetailInfo.projectLampparamVo.colorType == 1 && currentDetailInfo.projectLampparamVo.colorTemperatureStr != null && currentDetailInfo.projectLampparamVo.colorTemperatureStr != ''">{{currentDetailInfo.projectLampparamVo.colorTemperatureStr}}
                                            <span v-if="currentDetailInfo.projectLampparamVo.colorTemperatureStr > 1000">K</span>
                                        </span>
                                        <div  v-else>
                                            <table class="sdTable" border >
                                                <tbody v-for="(item,index) in currentDetailInfo.projectParamindexList" :key="index"> 
                                                    <tr v-if="index>=detailSkip">
                                                        <td>{{item.colorTemperatureStr}}</td>
                                                        <td><el-form-item v-show="item.colorPower != null && item.colorPower != ''"> ≤{{item.colorPower}} W</el-form-item></td>
                                                        <td><el-form-item> {{item.colorCoordinate}}</el-form-item></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                </div>
                            </li>
                            <li class="cd7">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                       表面温度
                                    </div>
                                </div>
                            </li>
                            <li class="cd9">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                        {{currentDetailInfo.projectLampparamVo.surfaceTemperature}}
                                    </div>
                                </div>
                            </li>
                            </ul>
                            </li>
                            <li class="cd7">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                       灯具颜色
                                    </div>
                                </div>
                            </li>
                            <li class="cd9">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                        {{currentDetailInfo.projectLampparamVo.lampColor}}
                                    </div>
                                </div>
                            </li>
                            <li class="cd7">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                       防护等级
                                    </div>
                                </div>
                            </li>
                            <li class="cd9">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                        {{currentDetailInfo.projectLampparamVo.protectLevel}}
                                    </div>
                                </div>
                            </li>

                            <li class="cd7">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                       材质
                                    </div>
                                </div>
                            </li>
                            <li class="cd9">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                        {{currentDetailInfo.projectLampparamVo.lampQuality}}
                                        {{currentDetailInfo.projectLampparamVo.materialQuality}}
                                    </div>
                                </div>
                            </li>

                            <li class="cd7">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                        <div v-if="currentDetailInfo.projectLampparamVo.lampType==227 || currentDetailInfo.projectLampparamVo.lampType ==1747 || currentDetailInfo.projectLampparamVo.lampType ==1748">IK等级</div>
                                        <div v-else>重量</div>

                                    </div>
                                </div>
                            </li>
                            <li class="cd9">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                        <span v-if="currentDetailInfo.projectLampparamVo.lampType==227 || currentDetailInfo.projectLampparamVo.lampType ==1747 || currentDetailInfo.projectLampparamVo.lampType ==1748" v-show="currentDetailInfo.projectLampparamVo.protectLevelIk != ''">{{currentDetailInfo.projectLampparamVo.protectLevelIk}}</span>
                                        <span v-else> <span v-if="currentDetailInfo.projectLampparamVo.weight != null && currentDetailInfo.projectLampparamVo.weight != ''">≤{{currentDetailInfo.projectLampparamVo.weight}} KG</span> </span>



                                    </div>
                                </div>
                            </li>

                            <li class="cd7" style="height:45px">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                       附件要求
                                    </div>
                                </div>
                            </li>
                            <li class="cd9" style="height:45px">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                        {{currentDetailInfo.projectLampparamVo.attachDemand}}
                                    </div>
                                </div>
                            </li>
                            <li class="cd7" style="height:45px">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                       安装方式
                                    </div>
                                </div>
                            </li>
                            <li class="cd9" style="height:45px">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                        {{currentDetailInfo.projectLampparamVo.installType}}
                                    </div>
                                </div>
                            </li>

                            <li class="cd7" style="height:45px" v-show="currentDetailInfo.projectLampparamVo.controlDigit != null && currentDetailInfo.projectLampparamVo.controlDigit != ''">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                       控制位数
                                    </div>
                                </div>
                            </li>
                            <li class="cd9" style="height:45px" v-show="currentDetailInfo.projectLampparamVo.controlDigit != null && currentDetailInfo.projectLampparamVo.controlDigit != ''">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                        {{currentDetailInfo.projectLampparamVo.controlDigit}}
                                    </div>
                                </div>
                            </li>
                            <li class="title">控制要求</li>
                             <li class="cd7">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                       是否带控
                                    </div>
                                </div>
                            </li>
                            <li class="cd9">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                        {{currentDetailInfo.projectLampparamVo.isControl == true ? '是' : "否"}}
                                    </div>
                                </div>
                            </li>
                             <li class="cd7">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                       控制协议
                                    </div>
                                </div>
                            </li>
                            <li class="cd9">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                        {{currentDetailInfo.projectLampparamVo.controlProtocol}} 
                                        <!-- {{currentDetailInfo.projectLampparamVo.controlProtocol2}}  -->
                                    </div>
                                </div>
                            </li>
                            <li style="padding:0;border:none;border-bottom: solid 1px rgba(184, 205, 217, 0.4);width:100%;">
                                <ul style="display: flex;display: -webkit-flex;">
                                    <li class="cd7" style="height:auto">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                       动态效果
                                    </div>
                                </div>
                            </li>
                            <li class="cd9" style="height:auto">
                                <div class="BoxTable">
                                    <div class="BoxCell" v-html="currentDetailInfo.projectLampparamVo.colorDemand">
                                    </div>
                                </div>
                            </li>
                            <li class="cd7" style="height:auto">
                                <div class="BoxTable">
                                    <div class="BoxCell">
                                       其他要求
                                    </div>
                                </div>
                            </li>
                            <li class="cd9" style="height:auto">
                                <div class="BoxTable">
                                    <div class="BoxCell" v-html="currentDetailInfo.projectLampparamVo.otherDemand">
                                        
                                    </div>
                                </div>
                            </li>
                                </ul>
                            </li>
                            
                        </ul>
                        <div class="lsdeList" v-if="showDetailFlag">
                            <ul>
                                <template v-if="isgdorPending==0 && userhaveRole">
                                <li @click="showAddToMyProject(2)"><img src="@/assets/images/bb1.jpg" alt="">添加至我的项目</li>  

                                <li v-if="currentDetailInfo.projectLampparamVo.dataStatus != 4 && currentDetailInfo.projectLampparamVo.makingWay==2" @click="showPDFEditView(currentDetailInfo.projectLampparamVo.id)"><img src="@/assets/images/bb3.jpg" alt="">修改</li>  
                                <li v-else-if="currentDetailInfo.projectLampparamVo.dataStatus != 4 && currentDetailInfo.projectLampparamVo.makingWay==1" @click="gotoUpdate(currentDetailInfo.projectLampparamVo.id)"><img src="@/assets/images/bb3.jpg" alt="">修改</li>   
                                <li v-show="currentDetailInfo.projectLampparamVo.dataStatus == 2" @click="audit(currentDetailInfo.projectLampparamVo.id)"><i class="el-icon-folder-checked"></i>提交审核</li>  
                                <!-- <li @click="deleteLampParam(currentDetailInfo.projectLampparamVo.id)"><img src="@/assets/images/bb4.jpg" alt="">删除</li>   -->
                                <li v-show="currentDetailInfo.projectLampparamVo.makingWay == 1" @click="downloadDetaildWorld()"><img src="@/assets/images/bb5.jpg" alt="">导出word</li>  
                                <li @click="downloadDetaildPdf()"><img src="@/assets/images/bb6.jpg" alt="">导出pdf</li>  
                                </template>
                                <li @click="prev()"><img src="@/assets/images/bb7.jpg" alt="">上一条</li>  
                                <li @click="next()"><img src="@/assets/images/bb8.jpg" alt="">下一条</li>   
                            </ul>
                        </div>
                        <div class="lsdeList" v-else-if='isgdorPending!=6'> <!-- 项目库-->
                            <ul>
                                <li @click="copyLamparamProject(currentDetailInfo.projectLampparamVo.id)"><img src="@/assets/images/bb1.jpg" alt="">添加至我的项目</li>  
                            </ul>
                        </div>
                    </div>    
                </div>
            </div>
            </el-form>
        </el-dialog>
</template>
<script>
export default {
    data(){
        return{
            userhaveRole:false,
            isgdorPending:'',
            showDetail:false,
            currentDetailInfo : {
                projectLampparamVo:{},
                projectParamindexList:[{
                    brightnessAvgMin:''
                }]
            },
            showDetailFlag:true,
            detailSkip:1,
            targetProjectId:'',
            rerecommend:false,//点击推荐灯参的话  为真  默认为false
        }
    },
    methods:{
        copyLamparamProject(id){
            let self = this
            this.$http.postQuery('/api/lampparams/copyLamparam/2',{lampparamIds:id,targetProjectId:this.targetProjectId},function(res){
                self.$message({
                    message: "导入成功！",
                    type: "success"
                });
                self.$emit("refreshdetail")
            })
        },
        prev(){
            this.$emit("perv")
        },
        next(){
            this.$emit("next")
        },
        downloadDetaildPdf(){
            let self = this
            this.$http.get('/api/lampparams/downloadLampparamPdf/'+this.currentDetailInfo.projectLampparamVo.id,{},function(res){
                self.downloadFile(self.ImgPath + "/" + res.data.fileName)
            })
        },
        downloadFile(url){
            window.open(url)
        },
        downloadDetaildWorld(){
            let self = this
            this.$http.get('/api/lampparams/downloadLampparamWord/'+this.currentDetailInfo.projectLampparamVo.id,{},function(res){
                console.log(self.ImgPath)
                self.downloadFile(self.ImgPath + "/" +res.data.fileName)
            })
        },
        audit(id){
            this.$emit("audit",id)
        },
        gotoUpdate(id){
            this.$emit("gotoUpdate",id)
        },
        showPDFEditView(id){
            this.$emit("showPDFEditView",id)
        },
        showAddToMyProject(type){
            this.$emit("showAddToMyProject",type)
        },
        show(id,flag,isgdorPending,userhaveRole,targetProjectId,rerecommend){
            this.isgdorPending = isgdorPending
            this.userhaveRole = userhaveRole;
            
            this.rerecommend = rerecommend;
            let self = this
            self.currentDetailInfo = {
                projectLampparamVo:{},
                projectParamindexList:[{
                    brightnessAvgMin:''
                }]
            }

            if(flag == false){
                self.showDetailFlag = flag
                self.isgdorPending = 6;
            }else{
                self.showDetailFlag = true
            }

            self.showDetail = true
            self.targetProjectId = targetProjectId
            this.$http.get('/api/lampparams/view/'+id,{},function(res){
                if(res.success){
                    self.currentDetailInfo = res.data
                    if(self.currentDetailInfo.projectLampparamVo.contestTypeString == '窗框' || self.currentDetailInfo.projectLampparamVo.contestTypeString == '复合面'){
                        self.detailSkip = 2
                    }else{
                        self.detailSkip = 1
                    }
                    self.$emit("setDetailInfo",res.data)
                }
            })
        }
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" >
#typeshowhtml{
    background: rgba(0,0,0,.4);
    z-index: 99;
    .toppom{
        ul{
            max-height: 70vh;
         overflow: auto
        }
    }
    .el-dialog{
        width: 86%;
         margin-top: 5vh !important;
         
    }
    .el-dialog__body{
            padding-top: 0;
        }
    .contrascont{
        min-height: 120px;
        min-width: 260px;
        display: inline-block;
        vertical-align: middle;  
        font-size: 18px;
        text-align: left;
        overflow: hidden;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        padding: 0px !important;
        width: 100%;
        .hst{
            font-size:22px;
            font-weight: bold;
            color: #000;
            margin-bottom: 10px;
            text-align: center;
        }
        .lsde{
            img{
                max-height: 100%;
            }
            li{
                float: left;
                text-align: center;
                border: solid 1px rgba(184, 205, 217, 0.4);
                padding: 10px 12px;
                font-size: 14px;
                margin: 0;
            }
           .title{
               height: 48px;
                background-color: #5a63a3;
                text-align: center;
                line-height: 48px;
                color: #fff;
                font-size: 18px;
                width: 100%;
                padding: 0;
           }
           .cd1{
               background-color: #f6f7fb;
               text-align: center;
               height: 200px;
               width: 9%;
           }
           .cd2{
               width: 41%;
               height: 200px;
           }
           .cd3{
               width: 9%;
                background-color: #f6f7fb;
                height: 50px;
           }
           .cd4{
               width: 16%;
               height: 50px;
               text-align: left;
               padding: 0 12px;
           }
           .cd5{
               width: 50%;
               height: 50px;
               text-align: left;
                padding: 0 12px;
           }
           .cd6{
               width: 91%;
               padding: 15px 2%;
           }
           .cd7{
               height: 45px;
                background-color: #f6f7fb;
                width: 9%;
           }
           .cd8{
               height: 45px;
               width: 91%;
               text-align: left;
               padding: 0 15px;
           }
           .cd9{
               height: 45px;
               width: 41%;
               text-align: left;
               padding: 0 15px;
               .BoxTable{
                   height: 45px;
                   .BoxCell{
                       height: 45px;
                       div{
                           display: inline-block;
                           width: auto;
                       }
                   }
               }
           }
        }
        .lsdeList{
            text-align: right;
            margin-top: 20px;
            li{
                display: inline-block;
                margin-left: 16px;
                float: none;
                border: none;
                color: #666666;
                font-size: 14px;
                cursor: pointer;
                img{
                    display: inline-block;
                    position: relative;
                    top: 3px;
                    margin-right: 3px;
                }
            }
        }
        .close{
            position: absolute;
            right: 10px;
            top: 10px;
            background-color: #5a63a3;
            width: 28px;
            height: 28px;
            display: inline-block;
            color: #fff;
            border-radius: 50%;
            line-height: 28px;
            text-align: center
        }
    }
}
</style>